import { FC, useState } from 'react';
import { Tooltip } from '@mui/material';

import { CustomAlert } from '../../../shared/uiComponents';
import { DetailedInfo } from '../User/tableInfo';
import { Info } from '../../../shared/Assets/svgIcons';

import { SoapNotesFullProperties } from '../../../redux/API/ClientAPIHelpers/soapNoteProperties';

const Details: FC<{ data: SoapNotesFullProperties }> = ({ data }) => {
	const [openInfo, setOpenInfo] = useState<boolean>(false);

	return (
		<>
			<Tooltip title="More Information">
				<div onClick={() => setOpenInfo(true)}>
					<Info />
				</div>
			</Tooltip>

			<CustomAlert
				open={openInfo}
				onClose={() => setOpenInfo(false)}
				title="More Information"
				Content={() => <DetailedInfo note={data} />}
			/>
		</>
	);
};

export default Details;
